import { Card, SxProps, Theme } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';

interface IProps {
  onClick?: () => void;
  children?: React.ReactNode;
  minHeight?: number | string;
  sx?: SxProps<Theme>;
  variant?: 'outlined' | 'elevation';
}

export function FSCard({
  onClick,
  children,
  minHeight,
  sx,
  variant = 'outlined',
}: IProps) {
  return (
    <Card
      variant={variant}
      onClick={onClick}
      sx={{
        minHeight: minHeight || undefined,
        backgroundColor:
          variant === 'outlined'
            ? ColorsRaw.anthracite.Anthracite_1
            : ColorsRaw.anthracite.Anthracite_3,
        borderRadius: '0.5rem',
        borderWidth: '1px',
        borderColor: ColorsRaw.anthracite.Anthracite_5,
        cursor: onClick ? 'pointer' : 'auto',
        '&:hover': {
          filter: onClick ? 'brightness(1.1)' : 'none',
        },
        ...sx,
      }}
    >
      {children}
    </Card>
  );
}
